<template>
  <div>
    <div class="nav">
      <div class="nav-left"><img src="../assets/img/index/join.jpg" alt=""></div>
      <div class="nav-center">
        <ul class='nav-center-li'>
          <router-link to='/'>
            <li>首页</li>

          </router-link>
          <router-link to='/DoubleClass'>
            <li>最新双师课程加盟</li>
          </router-link>

          <router-link to='/Group'>
            <li id='group'>集团介绍</li>
          </router-link>

          <router-link to='/JoinUs'>
            <li>优势亮点</li>
          </router-link>

          <router-link to='/Blockbuster'>
            <li>加盟展示</li>
          </router-link>

          <router-link to='/JoiningProcess'>
            <li>加盟流程</li>
          </router-link>

          <router-link to='/StemClass'>
            <li>STEM课程</li>
          </router-link>

          <router-link to='/JoinQuery'>
            <li>加盟查询</li>
          </router-link>
          
          <router-link to='/About'>
            <li>联系我们</li>
          </router-link>

        </ul>
    </div>

    <!-- <div class="nav-right" id="blink">官网热线：400-080-6869</div> -->
   <!--  <div style="margin-top:-1.5rem;position: absolute;right:5rem;color:white;font-weight: bold">加盟热线：010–65229883</div> -->
    </div>
    <div style="height: 80px"></div>
  </div>
</template>
<script>
// import { fontColor } from '../assets/js/fontColor'
export default {
  name: 'Nav',
  data () {
    return {}
  },
  mounted: function () {
    // setInterval(this.fontColor, 100)
  },
  methods: {
    fontColor: function () {
      // var color = '#f00|#0f0|#00f|#880|#808|#088|yellow|green|blue|gray|#008000'
      // color = color.split('|')
      // document.getElementById('blink').style.color = color[parseInt(Math.random() * color.length)]
    }
  }
}
</script>

<style>
  @import '../assets/scss/style.scss';
  *{
    padding: 0;
    margin:0;
  }
  .nav{
    width:100%;
    height:5rem;
    background:#00A0EA;
    /*box-sizing: border-box;*/
    position: fixed;
    top:0px;
    z-index: 10;
  }
  .nav-left{
    width:20%;
    text-align: right;
  }
  .nav-left img{
    height:5rem;
  }
  .nav-center{
    width:60%;
    margin-left:25%;
    margin-top:-4rem;
    overflow: auto;
  }
  .nav-center-li li{
    float:left;
    margin:1rem;
    list-style: none;
  }

  .nav-right{
    width:20%;
    position: absolute;
    right: -3rem;
    top:2rem;
    font-family: Verdana;
    overflow: hidden;
  }
  .nav-center-li a {
    color: white;
    font-weight: bold;
    box-sizing: border-box;
  }

  .nav-center-li a:hover {
    color: #ccc;
    border-bottom: 3px solid white;
  }

  .nav-center-li a.router-link-active {
    /*color: blue;*/
    border-bottom: 3px solid white;

  }
  .nav-center-li a.router-link-active {
    /*color: blue;*/
    /*border-bottom: 3px solid white;*/

  }
</style>
